import { useEffect, useState } from 'react';

import { Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';

import { getIntlLocale } from '@/shared/i18n';

import { formatDayTime, relativeTimeLabel } from './format';

export interface RelativeTimeProps extends Omit<TypographyProps, 'component'> {
  value: string;
  /** Refresh interval in ms so a long-open page doesn't show a stale "5 min ago". Default 30s. */
  refreshMs?: number;
}

/**
 * A self-refreshing relative-time label ("5 minutes ago") with the absolute day/time as its tooltip —
 * shared by the inbox row, the header captions, the Sessions/Episodes cards and Customer 360.
 */
export function RelativeTime({ value, refreshMs = 30_000, ...typographyProps }: RelativeTimeProps) {
  const [, forceRender] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => forceRender((n) => n + 1), refreshMs);
    return () => window.clearInterval(id);
  }, [refreshMs]);

  const locale = getIntlLocale();
  return (
    <Typography component="span" title={formatDayTime(value, locale)} {...typographyProps}>
      {relativeTimeLabel(value, locale)}
    </Typography>
  );
}
